import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
export default function AdminLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { user, signIn } = useAuth();
    const navigate = useNavigate();
    // Redirect if already logged in
    if (user) {
        return <Navigate to='/admin' replace/>;
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        const { error } = await signIn(email, password);
        if (error) {
            setError('ログインに失敗しました。メールアドレスとパスワードを確認してください。');
        }
        else {
            navigate('/admin');
        }
        setLoading(false);
    };
    return (<div className='min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8'>
      <div className='sm:mx-auto sm:w-full sm:max-w-md'>
        <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className='text-center'>
          <h1 className='text-4xl font-bebas tracking-wider text-navy'>
            MORIDEN SETSUBI
          </h1>
          <h2 className='mt-6 text-3xl font-bold text-gray-900'>
            管理者ログイン
          </h2>
          <p className='mt-2 text-sm text-gray-600'>
            ブログ管理システムにアクセスするにはログインが必要です
          </p>
        </motion.div>
      </div>

      <div className='mt-8 sm:mx-auto sm:w-full sm:max-w-md'>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }} className='bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10'>
          <form className='space-y-6' onSubmit={handleSubmit}>
            {error && (<div className='bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md text-sm'>
                {error}
              </div>)}

            <div>
              <label htmlFor='email' className='block text-sm font-medium text-gray-700'>
                メールアドレス
              </label>
              <div className='mt-1 relative'>
                <input id='email' name='email' type='email' autoComplete='email' required value={email} onChange={(e) => setEmail(e.target.value)} className='appearance-none block w-full px-3 py-2 pl-10 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-skyblue focus:border-skyblue sm:text-sm'/>
                <Mail className='absolute left-3 top-2.5 h-4 w-4 text-gray-400'/>
              </div>
            </div>

            <div>
              <label htmlFor='password' className='block text-sm font-medium text-gray-700'>
                パスワード
              </label>
              <div className='mt-1 relative'>
                <input id='password' name='password' type={showPassword ? 'text' : 'password'} autoComplete='current-password' required value={password} onChange={(e) => setPassword(e.target.value)} className='appearance-none block w-full px-3 py-2 pl-10 pr-10 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-skyblue focus:border-skyblue sm:text-sm'/>
                <Lock className='absolute left-3 top-2.5 h-4 w-4 text-gray-400'/>
                <button type='button' onClick={() => setShowPassword(!showPassword)} className='absolute right-3 top-2.5 h-4 w-4 text-gray-400 hover:text-gray-600'>
                  {showPassword ? <EyeOff size={16}/> : <Eye size={16}/>}
                </button>
              </div>
            </div>

            <div>
              <button type='submit' disabled={loading} className='w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-navy hover:bg-navy/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-skyblue disabled:opacity-50 disabled:cursor-not-allowed'>
                {loading ? (<div className='flex items-center'>
                    <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2'></div>
                    ログイン中...
                  </div>) : ('ログイン')}
              </button>
            </div>
          </form>

          <div className='mt-6'>
            <div className='relative'>
              <div className='absolute inset-0 flex items-center'>
                <div className='w-full border-t border-gray-300'/>
              </div>
            </div>


          </div>
        </motion.div>
      </div>
    </div>);
}
